import React from 'react';
import './Loading.css';

/**
 * Componente de carga reutilizable
 * @param {Object} props
 * @param {string} props.message - Mensaje opcional a mostrar
 * @param {string} props.size - Tamaño del spinner ('small', 'medium', 'large')
 * @param {boolean} props.fullScreen - Si debe ocupar toda la pantalla
 */
const Loading = ({ message = 'Cargando...', size = 'medium', fullScreen = false }) => {
  const sizeClass = `loading-spinner--${size}`;
  const containerClass = fullScreen ? 'loading-container--fullscreen' : 'loading-container';

  return (
    <div className={containerClass}>
      <div className="loading-content">
        <div className={`loading-spinner ${sizeClass}`}>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loading;

